import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext.tsx';
import { api_login } from '../services/auth.js';

interface UserData {
  CLI_CODIGO: string;
  CLI_NOME: string;
  CLI_CNPJCPF: string;
  CLI_TIPOCADAST: string;
  CLI_CONTATO: string;
  CLI_RESENDCOMPLEM: string;
  CLI_RESBAIRRO: string;
  CLI_RESTELEFONE: string;
  NATU_CODIGO: string;
  BANCO_CODIGO: string;
  PRECO_TABELA: string;
  CIDADE_CODDNERESID: string;
  COND_CODIGO: string;
  COND_DESDOBRAMENTO01: string;
  COND_DESDOBRAMENTO02: string;
  COND_DESDOBRAMENTO03: string;
  COND_DESDOBRAMENTO04: string;
  REPRE_CODIGO: string;
  REPRE_DESCRICAO: string;
}

interface AuthContextType {
  isAuthenticated: boolean;
  loading: boolean;
  login: (cpfCnpj: string, password: string) => Promise<void>;
  logout: () => void;
  userData: UserData | null;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [userData, setUserData] = useState<UserData | null>(null); 
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 
  const navigate = useNavigate();
  const { clearCart } = useCart();

  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    const storedUser = localStorage.getItem('userData');
  
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
  
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          if (parsedUser && typeof parsedUser === 'object') {
            setUserData(parsedUser);
          } else {
            console.warn("userData inválido no localStorage.");
          }
        } catch (error) {
          console.error("Erro ao fazer parse do userData:", error);
        }
      }
    }
  
    setLoading(false);
  }, []);

  const login = async (cpfCnpj: string, password: string) => {
    try {
      const response = await api_login(cpfCnpj, password);
      var data = response.data;

      if (data.sucesso) {
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("userData", JSON.stringify(data.dados));
        setIsAuthenticated(true); // importante para que ProtectedRoutes funcione corretamente.
        setUserData(data.dados);
        navigate('/home');
      } else {
        throw { tipo: data.tipo, mensagem: data.mensagem };
      }
    } catch (error: any) {
      throw error?.mensagem || 'Erro ao tentar login';
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUserData(null);
    clearCart();
    localStorage.removeItem('userData');
    localStorage.removeItem('isAuthenticated');
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout, userData }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
